import { useQuery } from "@tanstack/react-query";
import { Warehouse } from "lucide-react";
import api from "@/lib/api";
import { fmtNum } from "@/lib/format";
import { LocationMail } from "@/components/scm/LocationMail";
import { useWarehouseLeaders } from "@/components/scm/WarehouseLeaders";

const LOC_CLS = { GOOD: "text-emerald-800", DA: "text-rose-700", DP: "text-orange-700", LIT: "text-slate-700" };

export function StockByWarehouse({ canEdit }) {
  const q = useQuery({ queryKey: ["scm-stock-wh"], queryFn: async () => (await api.get("/scm/stock/by-warehouse")).data });
  const lq = useWarehouseLeaders();
  const rows = q.data?.rows || [];
  if (!rows.length) return null;
  return (
    <section className="pp-card p-4" data-testid="stock-by-warehouse">
      <div className="pp-label flex items-center gap-2 mb-3"><Warehouse size={14} /> Stock by warehouse · GOOD / DA / DP / LIT per plant</div>
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {rows.map((w) => (
          <div key={w.warehouse} className={`rounded-md border p-3 ${w.warehouse === "Unassigned" ? "border-dashed border-slate-300 bg-slate-50" : "border-slate-200 bg-white"}`} data-testid={`wh-card-${w.warehouse}`}>
            <div className="flex items-baseline justify-between gap-2">
              <div><div className="font-display text-base font-extrabold">{w.warehouse}</div><div className="text-[11px] text-slate-500">{w.name || (w.warehouse === "Unassigned" ? "movements posted without a warehouse" : "")}</div></div>
              <div className="text-right"><div className="font-mono text-sm font-bold" data-testid={`wh-value-${w.warehouse}`}>₹{fmtNum(Math.round(w.total_value))}</div><div className="text-[11px] text-slate-500">{w.skus} SKU(s)</div>{canEdit && <div className="mt-1"><LocationMail warehouse={w.warehouse} leader={lq.data?.[w.warehouse]} /></div>}</div>
            </div>
            <table className="mt-2 w-full text-xs"><tbody>
              {(q.data.locations || []).map((l) => (
                <tr key={l.key} className="border-t border-slate-100"><td className={`py-1 font-mono font-bold ${LOC_CLS[l.key]}`}>{l.key}</td><td className="py-1 text-slate-500">{l.label}</td>
                  <td className={`py-1 text-right font-mono ${w.qty[l.key] ? LOC_CLS[l.key] : "text-slate-400"}`} data-testid={`wh-${w.warehouse}-${l.key}`}>{fmtNum(w.qty[l.key] || 0)} pcs</td>
                  <td className="py-1 text-right font-mono text-slate-600">₹{fmtNum(Math.round(w.value[l.key] || 0))}</td></tr>
              ))}
            </tbody></table>
          </div>
        ))}
      </div>
      <p className="mt-2 text-[11px] text-slate-400">Warehouse comes from the Warehouse column of the stock upload (plant code). Movements without one are shown as Unassigned.</p>
    </section>
  );
}
